import styled from '@emotion/styled';

import { forDesktop, forMobile, Tabs, theme } from '@/design-system';

export const MOBILE_PAGE_PADDING = theme.spacing[16];

export const PortfolioRoot = styled(Tabs.Root)({
  paddingBottom: 8,

  [forDesktop]: { paddingBottom: 0 },
});

export const PrimaryTabsScroller = styled('div')({
  width: '100%',
  paddingTop: 8,
  marginBottom: 24,

  [forDesktop]: {
    paddingTop: 0,
    marginBottom: 40,
  },
});

export const PrimaryTabsList = styled(Tabs.List)({
  '&&': {
    [forMobile]: {
      display: 'flex',
      width: '100%',
      overflowX: 'auto',
      overflowY: 'hidden',
      scrollbarWidth: 'none',
      WebkitOverflowScrolling: 'touch',

      '&::-webkit-scrollbar': { display: 'none' },

      '& > *': { flexShrink: 0 },
    },
  },
});

export const PrimaryTab = styled(Tabs.Tab)({
  position: 'relative',
  touchAction: 'manipulation',

  '&::after': {
    content: '""',
    position: 'absolute',
    insetBlock: -8,
    insetInline: 0,
  },

  [forDesktop]: {
    '&::after': { content: 'none' },
  },
});
